module.exports = __webpack_public_path__ + "img/carrefour.ee92fe7e.svg";